import React from "react";
import MyContainer from "@/components/MyContainer";
import DeliveryFeeAsyncTable from "@/pages/delivery-fee/component/delivery-fee-async-data-table";
import { LinkButton } from "@/components/ui/buttons/link-button";
import { useLocation } from "wouter";

export default function DeliveryFeePage() {
  const [, setLocation] = useLocation();

  const handleCreate = () => {
    setLocation("/delivery-fees/create");
  };

  return (
    <MyContainer
      title="Delivery Fees"
      enableBack={false}
      subtitle="Manage your delivery fee options"
      actions={<LinkButton label="Delivery Fee" onClick={handleCreate} />}
    >
      <DeliveryFeeAsyncTable />
    </MyContainer>
  );
}
